import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-20">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                善良的小姨子
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              本站为电视剧《善良的小姨子》相关内容展示平台，提供剧情介绍、演员资料与剧集信息。站内所有视频均为前端演示，图文数据均为演示示例，仅供浏览参考。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold text-base mb-4">
              <a href="#footer-nav" className="hover:text-accent-400 transition-colors">内容导航</a>
            </h4>
            <ul id="footer-nav" className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-300 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/plot" className="text-background-300 hover:text-accent-400 transition-colors">
                  剧情介绍
                </Link>
              </li>
              <li>
                <Link to="/category/cast" className="text-background-300 hover:text-accent-400 transition-colors">
                  演员列表
                </Link>
              </li>
              <li>
                <Link to="/special/recommend" className="text-background-300 hover:text-accent-400 transition-colors">
                  推荐专题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-semibold text-base mb-4">
              <a href="#footer-contact" className="hover:text-accent-400 transition-colors">联系方式</a>
            </h4>
            <ul id="footer-contact" className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
                <span>contact@shandexiaoyizi.demo</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
                <span>400-000-0000（演示）</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center"></i>
                <span>示例地址 · 影视内容演示站</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2024 善良的小姨子 · 影视内容演示站 | 本站为演示性质，不含真实播放与下载服务</p>
          <p className="flex items-center gap-4">
            <span>剧情介绍</span>
            <span>演员资料</span>
            <span>追剧推荐</span>
          </p>
        </div>
      </div>
    </footer>
  );
}